<template>
  <div id="app">
    <div class="row">
      <div class="col-12 d-flex justify-content-between align-items-center">
        <h2 ref="contractsTitle" class="generalTitle">Contratos</h2>
        <a
          v-if="$store.state.roles.Backoffice_member_empresas"
          href="#"
          class="btn-upload-csv"
          data-toggle="modal"
          data-target="#uploadPaymentCSVModal"
        >
          <v-icon name="bi-upload" scale="1.1"/> CARGAR PAGOS CSV
        </a>
        <a
          v-if="canRefreshPaymentPlans"
          href="#"
          class="btn-upload-csv"
          data-toggle="modal"
          data-target="#refreshPaymentPlansModal"
        >
          <v-icon name="bi-upload" scale="1.1"/> ACTUALIZAR PLANES DE PAGO
        </a>
      </div>
    </div>
    <div class="row mx-1">
      <div class="col-12 mb-3">
        <list-filters @filter="debouncedFilter" :filterURL="filterURL" :isLoading="isLoading" />
      </div>

      <!-- Barra de progreso, solo para la carga inicial -->
      <div v-if="loading && !loadingPagination" class="col-12 mb-3">
        <div class="progress-bar-container">
          <div class="progress-bar"></div>
        </div>
      </div>

      <!-- Contratos list -->
      <div class="col-12" v-if="!loading && contracts && contracts.length > 0">
        <div class="card" :class="{ 'card-versionMovil': !$store.state.responsive.viewDesktopLists}">
          <div class="card-body pb-0">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <p class="mb-2">Mostrando {{ from }}-{{ to }} de {{ totalItems }} contratos</p>
              <div class="dropdown dropdown-inherit" style="display: flex">
                <div v-if="$store.state.responsive.viewDesktopLists && !$store.state.roles.Backoffice_member_empresas" style="width: 190px;">
                  <a class="mr-4" href="#" @click="toggleShowMoreFields()" style="text-decoration: none;">
                    <div v-if="showMoreField">
                      <v-icon  name="la-minus-circle-solid" scale="0.9"/> Ocultar campos
                    </div>
                    <div v-if="!showMoreField">
                      <v-icon  name="bi-plus-circle" scale="0.9"/> Mostrar más campos
                    </div>
                  </a>
                </div>
                <a v-if="!$store.state.roles.Backoffice_member_empresas" class="mr-4" href="#" data-toggle="modal" data-target="#uploadData" @click="openModals('UploadCSVImeiTracking')">
                  <v-icon name="bi-upload" scale="1.1"/> CARGAR
                </a>
                <a href="#" data-toggle="modal" class="mr-4" data-target="#exportData" @click="downloadCSV()">
                  <v-icon name="bi-download" scale="1.1"/> DESCARGAR
                </a>


              </div>
            </div>
            <list :contracts="contracts" @selectOrder="selectOrder($event)" :showMoreField="showMoreField" :desktopViewFull="$store.state.responsive.viewDesktopSpecial" @refrestContractList="refrestContractList"/>
            <!-- Spinner de precarga al cambiar número de contratos -->
            <div v-if="loadingPagination" class="text-center mt-3 mb-3">
              <div class="spinner-border" role="status">
                <span class="sr-only">Cargando...</span>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-8 col-lg-5">
                <div class="form-group" v-if="numberPages > 1">
                  <div class="float-left mr-3 mt-2">
                    <select v-model="itemsPerPage" class="form-control" id="itemsPerPage" @change="changeItemsPerPage()">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                  <label for="itemsPerPage" class="col-form-label mt-2">Contratos por página</label>
                </div>
              </div>
              <div class="col-12 col-sm-4 col-lg-7" v-if="numberPages > 1">
                <pagination :currentPage="currentPage" :numberPages="numberPages" @selectPage="selectPage($event)" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 text-center" v-if="!loading && (!contracts || contracts.length === 0)">
        <div class="alert alert-info">No hay resultados para mostrar</div>
      </div>
    </div>

    <ExportData v-if="showModalDownload" :id="'exportData'" :modalTitle="'EXPORTAR DATOS'" :class="'modal-xl'" :showFooter="false" @hideModalDownload="hideModalDownload"
                :filters="filtros" :order="order" :statusSelected="statusSelected" />
    <ExportReport :id="'exportReport'" :modalTitle="'EXPORTAR INFORME'" :class="'modal-xl'" :showFooter="false"
                  :filters="filtros" :order="order" />
    <UploadCSVImeiTracking :contractIndex="contractIndex" :contractId="contractSelected" :id="'UploadCSVImeiTracking'"
                           :modalTitle="'CARGAR CSV'" :class="'modal-lg'" @loadSuccessModal="loadSuccessModal" @loadErrorModal="loadErrorModal">
    </UploadCSVImeiTracking>
    <ModalError :id="'modalError'" :modalTitle="'SE HA PRODUCIDO UN ERROR'" :class="'modal'" :showFooter="false"
                :message="errorMessage" :code="errorCode"/>
    <ModalSuccess :id="'modalSuccess'" :modalTitle="'SE HA ENVIADO CORRECTAMENTE'" :class="'modal'" :showFooter="false" />


    <ModalUploadPaymentCSV
        ref="uploadPaymentCSVModal"
        :id="'uploadPaymentCSVModal'"
        :modalTitle="'CARGAR PAGOS DE REMESAS'"
        @submitForm="handleUploadPaymentCSV"
    />

    <ModalRefreshPaymentPlans
        v-if="canRefreshPaymentPlans"
        :id="'refreshPaymentPlansModal'"
        :modalTitle="'ACTUALIZAR PLANES DE PAGO'"
    />

  </div>
</template>

<script>
import axios from 'axios';
import { debounce } from 'lodash';
import List from './templates/List.vue';
import ListFilters from '@/components/Widgets/Shared/ContractListFilters.vue';
import Pagination from '@/components/Widgets/Shared/Pagination.vue';
import ExportData from './templates/ExportData.vue';
import ExportReport from './templates/ExportReport.vue';
import UploadCSVImeiTracking from './templates/UploadCSVImeiTracking.vue';
import ModalError from '../../Shared/ModalError.vue';
import ModalSuccess from '../../Shared/ModalSuccess.vue';
import { Modal as ModalBootstrap } from "bootstrap";
import { useRoute } from 'vue-router';
import ModalUploadPaymentCSV from "./templates/ModalUploadPaymentCSV.vue";
import ModalRefreshPaymentPlans from "./templates/ModalRefreshPaymentPlans.vue";

export default {
  name: 'App',
  data() {
    return {
      loading: true,
      loadingPagination: false,
      statusSelected: '',
      name: '',
      surnames: '',
      documentNumber: '',
      documentNumberCompany: '',
      CNAENumber: '',
      shop: '',
      contractNumber: '',
      fromDate: '',
      toDate: '',
      phone: '',
      status: '',
      channel: '',
      tenant: '',
      imei: '',
      policy: '',
      merchant: '',
      email: '',
      direction: '',
      contracts: [],
      filters: '',
      type: '',
      group: '',
      reasonAccepted: '',
      itemsPerPage: 25,
      currentPage: 0,
      totalItems: 0,
      numberPages: 0,
      from: 0,
      to: 0,
      order: '',
      filtros: {
        contractId: null,
        legalIdentifier: null,
        name: null,
        phone: null,
        surnames: null,
        date: null,
        dateFrom: null,
        dateTo: null,
        endDate: null,
        status: null,
        channel: null,
        tenant: null,
        imei: null,
        policy: null,
        merchant: null,
        email: null,
        direction: null,
        storeNumber: null,
        type: null,
        group: null,
        realEndDateFrom: null,
        realEndDateTo: null,
        reasonAccepted: null
      },
      showMoreField: false,
      showModalDownload: false,
      filterURL: '',
      isLoading: false,
      realEndDateFrom: '',
      realEndDateTo: '',
    };
  },
  components: {
    ModalUploadPaymentCSV,
    ModalRefreshPaymentPlans,
    List,
    ListFilters,
    Pagination,
    ExportData,
    ExportReport,
    ModalError,
    ModalSuccess,
    UploadCSVImeiTracking
  },
  created() {
    const route = useRoute();
    const filterURL = route.query.filterURL;
    if(filterURL && filterURL !== '') {
      this.filterURL = filterURL;
    } else {
      this.loadContracts();
    }
    this.debouncedFilter = debounce(this.filter, 300); // Implementación de debounce
  },
  computed: {
    canRefreshPaymentPlans() {
      const { Backoffice_member, Backoffice_member_empresas } = this.$store.state.roles;
      return Backoffice_member && !Backoffice_member_empresas;
    },
  },
  methods: {
    filter(value) {
      this.isLoading = true;
      this.name = value.name !== undefined ? value.name : this.name;
      this.surnames = value.surnames !== undefined ? value.surnames : this.surnames;
      this.documentNumber = value.documentNumber !== undefined ? value.documentNumber : this.documentNumber;
      this.shop = value.shop !== undefined ? value.shop : this.shop;
      this.contractNumber = value.contractNumber !== undefined ? value.contractNumber : this.contractNumber;
      this.fromDate = value.from !== undefined ? value.from : this.fromDate;
      this.toDate = value.to !== undefined ? value.to : this.toDate;
      this.phone = value.mobile !== undefined ? value.mobile : this.phone;
      this.status = value.status !== undefined ? value.status : this.status;
      this.channel = value.channel !== undefined ? value.channel : this.channel;
      this.tenant = value.tenant !== undefined ? value.tenant : this.tenant;
      this.imei = value.imei !== undefined ? value.imei : this.imei;
      this.policy = value.policy !== undefined ? value.policy : this.policy;
      this.merchant = value.merchant !== undefined ? value.merchant : this.merchant;
      this.email = value.email !== undefined ? value.email : this.email;
      this.direction = value.direction !== undefined ? value.direction : this.direction;
      this.type = value.typeStatus !== undefined ? value.typeStatus : this.type;
      this.group = value.subtypeStatus !== undefined ? value.subtypeStatus : this.group;
      this.realEndDateFrom = value.realEndDateFrom !== undefined ? value.realEndDateFrom : this.realEndDateFrom;
      this.realEndDateTo = value.realEndDateTo !== undefined ? value.realEndDateTo : this.realEndDateTo;
      this.reasonAccepted = value.reasonAccepted !== undefined ? value.reasonAccepted : this.reasonAccepted;

      // Sincronizar el objeto filtros con los filtros activos
      this.filtros = {
        ...this.filtros,
        ...value,
        realEndDateFrom: value.realEndDateFrom ? this.$dateFrontToBack(value.realEndDateFrom) : null,
        realEndDateTo: value.realEndDateTo ? this.$dateFrontToBack(value.realEndDateTo) : null,
        dateFrom: value.from ? this.$dateFrontToBack(value.from) : null,
        dateTo: value.to ? this.$dateFrontToBack(value.to) : null,
      };
      console.log('[EXPORT] Filtros sincronizados para exportación:', this.filtros);

      this.currentPage = 0;
      this.loadContracts();
    },
    filterName() {
      if (this.name !== '' && this.name !== undefined) {
        this.filters = `${this.filters}&customer.name=${this.name}`;
        this.filtros.name = this.name;
      } else {
        this.filtros.name = null;
      }
    },
    filterSurnames() {
      if (this.surnames !== '' && this.surnames !== undefined) {
        this.filters = `${this.filters}&customer.surnames=${this.surnames}`;
        this.filtros.surnames = this.surnames;
      } else {
        this.filtros.surnames = null;
      }
    },
    filterDocumentNumber() {
      if (this.documentNumber !== '' && this.documentNumber !== undefined) {
        this.filters = `${this.filters}&customer.legalIdentifier=${this.documentNumber}`;
        this.filtros.legalIdentifier = this.documentNumber;
      } else {
        this.filtros.legalIdentifier = null;
      }
    },
    filterDocumentNumberCompany() {
      if (this.documentNumberCompany !== '' && this.documentNumberCompany !== undefined) {
        this.filters = `${this.filters}&customer.legalIdentifier=${this.documentNumberCompany}`;
        this.filtros.legalIdentifier = this.documentNumberCompany;
      } else {
        this.filtros.legalIdentifier = null;
      }
    },
    filterContractNumber() {
      if (this.contractNumber !== '' && this.contractNumber !== undefined) {
        this.filters = `${this.filters}&contractId=${this.contractNumber}`;
        this.filtros.contractId = this.contractNumber;
      } else {
        this.filtros.contractId = null;
      }
    },
    filterShop() {
      if (this.shop !== '' && this.shop !== undefined) {
        this.filters = `${this.filters}&storeNumber=${this.shop}`;
        this.filtros.storeNumber = this.shop;
      } else {
        this.filtros.storeNumber = null;
      }
    },
    filterFrom() {
      if (this.fromDate !== '' && this.fromDate !== undefined) {
        this.filters = `${this.filters}&dateFrom=${this.$dateFrontToBack(this.fromDate)}`;
        this.filtros.dateFrom = this.fromDate;
      } else {
        this.filtros.dateFrom = null;
      }
    },
    filterTo() {
      if (this.toDate !== '' && this.toDate !== undefined) {
        this.filters = `${this.filters}&dateTo=${this.$dateFrontToBack(this.toDate)}`;
        this.filtros.dateTo = this.toDate;
      } else {
        this.filtros.dateTo = null;
      }
    },
    filterPhone() {
      if (this.phone !== '' && this.phone !== undefined) {
        this.filters = `${this.filters}&customer.phone1=${this.phone}`;
        this.filtros.phone = this.phone;
      } else {
        this.filtros.phone = null;
      }
    },
    filterStatus() {
      if (this.status !== '' && this.status !== undefined) {
        if (!this.$store.state.roles.Backoffice_member_empresas) {
          this.filters = `${this.filters}&statuses=${this.status}`;
          if (this.status == 'DENIED') this.filters = `${this.filters}&statuses=DENIED_BY_STOCKOUT`;
        } else {
          this.filters = `${this.filters}&status=${this.status}`;
        }
        this.filtros.status = this.status;
      } else {
        this.filtros.status = null;
      }
    },
    filterType() {
      if (this.type !== '' && this.type !== undefined) {
        this.filters = `${this.filters}&type=${this.type}`;
        this.filtros.type = this.type;
      } else {
        this.filtros.type = null;
      }
    },
    filterSubtype() {
      if (this.group !== '' && this.group !== undefined) {
        this.filters = `${this.filters}&group=${this.group}`;
        this.filtros.group = this.group;
      } else {
        this.filtros.group = null;
      }
    },
    filterChannel() {
      if (this.channel !== '' && this.channel !== undefined) {
        this.filters = `${this.filters}&channel=${this.channel}`;
        this.filtros.channel = this.channel;
      } else {
        this.filtros.channel = null;
      }
    },
    filterTenant() {
      if (this.tenant !== '' && this.tenant !== undefined) {
        this.filters = `${this.filters}&merchant=${this.tenant}`;
        this.filtros.tenant = this.tenant;
      } else {
        this.filtros.tenant = null;
      }
    },
    filterImei() {
      if (this.imei !== '' && this.imei !== undefined) {
        this.filters = `${this.filters}&product.imei=${this.imei}`;
        this.filtros.imei = this.imei;
      } else {
        this.filtros.imei = null;
      }
    },
    filterPolicy() {
      if (this.policy !== '' && this.policy !== undefined) {
        this.filters = `${this.filters}&policy.policyNumber=${this.policy}`;
        this.filtros.policy = this.policy;
      } else {
        this.filtros.policy = null;
      }
    },
    filterMerchant() {
      if (this.merchant !== '' && this.merchant !== undefined) {
        this.filters = `${this.filters}&merchantOrderId=${this.merchant}`;
        this.filtros.merchant = this.merchant;
      } else {
        this.filtros.merchant = null;
      }
    },
    filterEmail() {
      if (this.email !== '' && this.email !== undefined) {
        this.filters = `${this.filters}&customer.email=${this.email}`;
        this.filtros.email = this.email;
      } else {
        this.filtros.email = null;
      }
    },
    filterDirection() {
      if (this.direction !== '' && this.direction !== undefined) {
        this.filters = `${this.filters}&deliveryAddress.street=${this.direction}`;
        this.filtros.direction = this.direction;
      } else {
        this.filtros.direction = null;
      }
    },
    filterRealEndDateFrom() {
      if (this.realEndDateFrom !== '' && this.realEndDateFrom !== undefined) {
        // Convertir a formato YYYY-MM-DD
        const from = this.$dateFrontToBack(this.realEndDateFrom);
        this.filters = `${this.filters}&realEndDateFrom=${from}`;
        this.filtros.realEndDateFrom = this.realEndDateFrom;
      } else {
        this.filtros.realEndDateFrom = null;
      }
    },
    filterRealEndDateTo() {
      if (this.realEndDateTo !== '' && this.realEndDateTo !== undefined) {
        // Convertir a formato YYYY-MM-DD
        const to = this.$dateFrontToBack(this.realEndDateTo);
        this.filters = `${this.filters}&realEndDateTo=${to}`;
        this.filtros.realEndDateTo = this.realEndDateTo;
      } else {
        this.filtros.realEndDateTo = null;
      }
    },
    filterReasonAccepted() {
      if (this.reasonAccepted !== '' && this.reasonAccepted !== undefined && this.reasonAccepted !== null) {
        this.filters = `${this.filters}&reasonAccepted=${this.reasonAccepted}`;
        this.filtros.reasonAccepted = this.reasonAccepted;
      } else {
        this.filtros.reasonAccepted = null;
      }
    },
    filterPagination() {
      if (this.$store.state.roles.Backoffice_member_empresas) {
        this.filters = `${this.filters}pageSize=${this.itemsPerPage}&`;
        this.filters = `${this.filters}page=${parseInt(this.currentPage + 1)}`;
      } else {
        this.filters = `${this.filters}pagination.pageSize=${this.itemsPerPage}&`;
        this.filters = `${this.filters}pagination.page=${parseInt(this.currentPage + 1)}`;
      }
    },
    selectPage(value) {
      this.currentPage = value;
      this.loading = true;
      this.scrollToTop();
      this.loadContracts();
    },
    scrollToTop() {
      const element = this.$refs.contractsTitle;
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    selectOrder(value) {
      console.log(value);
    },
    changeItemsPerPage() {
      this.loadingPagination = true;
      this.currentPage = 0;
      this.loadContracts();
    },
    loadContracts() {
      this.filters = '';
      this.filterPagination();
      this.filterName();
      this.filterSurnames();
      this.filterDocumentNumber();
      this.filterContractNumber();
      this.filterChannel();
      this.filterTenant();
      this.filterShop();
      this.filterStatus();
      this.filterFrom();
      this.filterTo();
      this.filterImei();
      this.filterPolicy();
      this.filterMerchant();
      this.filterPhone();
      this.filterEmail();
      this.filterDirection();
      this.filterType();
      this.filterSubtype();
      this.filterRealEndDateFrom();
      this.filterRealEndDateTo();
      this.filterReasonAccepted();

      if (!this.loadingPagination) {
        this.loading = true;
      }

      if (this.filters !== '') {
        this.filters = `?${this.filters}`;
      }

      const vm = this;
      let apiUrl = '';
      if (!this.$store.state.roles.Backoffice_member_empresas) {
        apiUrl = '/contract/search';
      } else {
        apiUrl = '/business/contract/search';
      }
      axios.get(apiUrl + `${this.filters}`)
          .then((response) => {
            this.loading = false;
            this.loadingPagination = false;
            this.isLoading = false;
            vm.contracts = response.data.contracts;
            vm.totalItems = response.data.pagination.totalElements;
            vm.numberPages = vm.totalItems % vm.itemsPerPage === 0
                ? vm.totalItems / vm.itemsPerPage
                : parseInt(vm.totalItems / vm.itemsPerPage, 10) + 1;

            vm.from = (vm.currentPage * vm.itemsPerPage) + 1;
            vm.to = (vm.currentPage * vm.itemsPerPage) + vm.itemsPerPage > vm.totalItems
                ? vm.totalItems
                : (vm.currentPage * vm.itemsPerPage) + vm.itemsPerPage;
          })
          .catch(() => {
            this.loading = false;
            this.loadingPagination = false;
            this.isLoading = false;
          });
    },
    downloadCSV() {
      this.showModalDownload=true;
      this.statusSelected = this.status;
    },
    openModals(identifier) {
      var myModal = new ModalBootstrap(document.getElementById(identifier))
      myModal.show()
    },
    loadSuccessModal(){
      var myModal = new ModalBootstrap(document.getElementById('modalSuccess'));
      myModal.show();
    },
    loadErrorModal(error){
      this.errorCode = error.response.data.code
      this.errorMessage = error.response.data.message
      var myModal = new ModalBootstrap(document.getElementById('modalError'));
      myModal.show();
    },
    toggleShowMoreFields(){
      this.showMoreField = !this.showMoreField;
    },
    hideModalDownload(){
      this.showModalDownload = false;
    },
    refrestContractList(payload) {
      // Keep List mounted during reload so open modals are not destroyed mid-transition
      this.loadingPagination = true;
      this.loadContracts();
      if (!payload?.silent) this.loadSuccessModal();
    },

    handleUploadPaymentCSV({ formData }) {
      const token = this.$cookies.get('token');
      const apiUrl = '/contract/business/update/payment-plan';

      console.log('[CARGAR PAGOS CSV] Enviando CSV de pagos de remesas');

      axios.patch(apiUrl, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      })
          .then(() => {
            const modal = this.$refs.uploadPaymentCSVModal;
            modal.successMessage = 'El archivo CSV se ha procesado exitosamente. Los planes de pago han sido actualizados.';
            modal.loading = false;

            // Recargar la lista de contratos
            this.loadContracts();

            setTimeout(() => {
              modal.closeModal();
            }, 5000);
          })
          .catch((error) => {
            const modal = this.$refs.uploadPaymentCSVModal;
            let errorMsg = 'Ocurrió un error al procesar el archivo CSV. Por favor, inténtalo de nuevo.';

            if (error.response) {
              if (error.response.status === 400) {
                errorMsg = 'El archivo CSV tiene un formato inválido. Verifica que contenga las cabeceras: CONTRACTID, CUOTA, ESTADO, FECHAPAGO';
              } else if (error.response.status === 401 || error.response.status === 403) {
                errorMsg = 'No tienes permisos para realizar esta operación.';
              } else if (error.response.data && error.response.data.message) {
                errorMsg = error.response.data.message;
              }
            }

            modal.errorMessage = errorMsg;
            modal.loading = false;
            setTimeout(() => {
              modal.resetForm();
            }, 5000);

            console.error('[CARGAR PAGOS CSV] Error:', error);
          });
    }

  }
};
</script>

<style lang="scss" scoped>
.dropzone-container {
  max-height: unset;
}

.progress-bar-container {
  width: 100%;
  height: 4px;
  background-color: #f3f3f3;
  position: relative;
  margin-bottom: 10px;
}

.progress-bar {
  width: 0;
  height: 100%;
  background-color: #97055D;
  animation: loading 2s infinite;
}

@keyframes loading {
  0% {
    width: 0;
  }
  50% {
    width: 50%;
  }
  100% {
    width: 100%;
  }
}

.spinner-border {
  width: 2rem;
  height: 2rem;
  border-width: 0.25rem;
  color: #cc0b7a;
}

.btn-upload-csv {
  color: #cc0b7a;
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 16px;
  border: 1px solid #cc0b7a;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #cc0b7a;
    color: white;
    text-decoration: none;
  }
}
</style>
